import { Outlet } from "react-router-dom";

const FinanceManagementMainPage = () => {
    return <Outlet />;
}

export default FinanceManagementMainPage;